import { render, staticRenderFns } from "./largeScreen.vue?vue&type=template&id=55b99917&scoped=true"
import script from "./largeScreen.vue?vue&type=script&lang=js"
export * from "./largeScreen.vue?vue&type=script&lang=js"
import style0 from "./largeScreen.vue?vue&type=style&index=0&id=55b99917&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b99917",
  null
  
)

export default component.exports